export default {
  state: {
    threeDimensionCar: {
      url: '',
      show: false,
      style: '',
      seriesId: 0,
      seriesName: ''
    },
    threeDimensionHall: {
      isOpen: false,
      url: '',
      show: false,
      style: ''
    },
    fullFrame: { width: '100%', height: '100%' }
  },
  mutations: {
    setThreeDimensionCar (state, { url = '',
      show = false, style = '', seriesId = 0, seriesName = '' }) {
      state.threeDimensionCar = { url, show, style, seriesId, seriesName };
    },
    setThreeDimensionCarSeriesInfo (state, { seriesId = 0, seriesName = '' }) {
      state.threeDimensionCar.seriesId = seriesId;
      state.threeDimensionCar.seriesName = seriesName;
    },
    setThreeDimensionHall (state, { url = '',
      show = false, style = '', isOpen = false }) {
      state.threeDimensionHall = { url, show, style, isOpen };
    },
    setFullFrame (state, { width = '100%', height = '100%' }) {
      state.fullFrame = { width, height };
    }
  },
  getters: {
    threeDimensionCar: state => state.threeDimensionCar,
    threeDimensionHall: state => state.threeDimensionHall,
    fullFrame: state => state.fullFrame
  },
  actions: {},
  namespaced: true
};
